import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

export const fetchBidangs = async (page = 1, per_page = 10, filters = {}) => {
  try {
    // Build query parameters
    const params = new URLSearchParams({
      page,
      per_page,
      ...(filters.jenisPaket && { jenis_paket: filters.jenisPaket }),
      ...(filters.jenisSeleksi && { jenis_seleksi: filters.jenisSeleksi }),
      ...(filters.kategoriPaket && { kategori_paket: filters.kategoriPaket })
    });

    const response = await axios.get(`${BASE_URL_BE}/bidang?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching paket:", error);
    throw error;
  }
};

export const createBidangs = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/bidang`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating paket:", error);
    throw error;
  }
};

export const updateBidangs = async (id_paket, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/bidang/${id_paket}`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};

export const deleteBidangs = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/bidang/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting paket:", error);
    throw error;
  }
};

export const listBidangs = async (jenisSeleksi, id_paket) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/bidang/list`, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      },
      params: {
        jenis_seleksi: jenisSeleksi,
        id_paket : id_paket
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};

export const getJenisSeleksi = async (jenisSeleksi) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/bidang/jenis_seleksi`, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      },
      params: {
        jenis_seleksi: jenisSeleksi
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};


